import { render, staticRenderFns } from "./CompaniesListPage.vue?vue&type=template&id=051e44da&scoped=true"
import script from "./CompaniesListPage.vue?vue&type=script&lang=ts"
export * from "./CompaniesListPage.vue?vue&type=script&lang=ts"
import style0 from "./CompaniesListPage.vue?vue&type=style&index=0&id=051e44da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051e44da",
  null
  
)

export default component.exports